import React, { createContext, useReducer } from 'react'
import tmpOrderReducer from './TmpOrderReducer'
const initialState = { tmpOrders: [], loading: true }

export const TmpOrderContext = createContext(initialState)

export const TmpOrderContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(tmpOrderReducer, initialState)
  console.log(state);
  function getAllTmpOrders(tmpOrders) {
    console.log("in context", tmpOrders);
    dispatch({
      type: 'GET_ALL_TMP_ORDERS',
      payload: tmpOrders,
    })
  }

  function addNewTmpOrder(tmpOrder) {
    dispatch({
      type: 'ADD_TMP_ORDER',
      payload: tmpOrder,
    })
  }

  return (
    <TmpOrderContext.Provider
      value={{
        getAllTmpOrders: getAllTmpOrders,
        addNewTmpOrder: addNewTmpOrder,
        tmpOrders: state.tmpOrders,
        loading: state.loading,
      }}
    >
      {children}
    </TmpOrderContext.Provider>
  )
}

// export {
//   TmpOrderContext, 
//   TmpOrderContextProvider, 
// }
